import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { AuthService } from 'src/app/core/services/auth.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-modal-condiciones',
  templateUrl: './modal-condiciones.component.html',
  styleUrls: ['./modal-condiciones.component.scss']
})
export class ModalCondicionesComponent implements OnInit {
  checkLeido;
  token;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private _authService: AuthService
  ) {
    this.checkLeido = false;
    this.token = JSON.parse(localStorage.getItem('usuario')).token;
   }

  ngOnInit(): void {
  }

  async download(){
    const pdfPath = '../../../../assets/docs/TerminosyCondicionesPortalWeb.pdf';
    const pdfName = 'Terminos y condiciones';
    FileSaver.saveAs(pdfPath, pdfName);
  }

  cerrarModal() {
    this.dialogRef.close({
      status: false
    });
    
  }

  async enviarData(){
    const req ={
      token: this.token
    };
    const response = await this._authService.aceptaCondiciones(req);
    if(response.error.codError == 0){
      this.dialogRef.close({
        status: true,
        aceptaTerminos: this.checkLeido
      })
    }else{
      this.dialogRef.close({
        status: false
      })
    }
    
  }

}
